var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content != '')?_c(_vm.tag,{ref:"localizedContentElement",tag:"component",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }